import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { CHANNELS_OPTIONS } from '../../../constants/gps';
import EnhancedLabeledSelect from '../../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: number;
  onChangeId?: (id?: number) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function DeviceChannelsSelect({
  selectedId,
  onChangeId,
  isFilter = true,
  label = 'Numero de canales:',
  emptyOptionText = 'Cuantos canales tiene el dispositivo',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const channelsOptions = useMemo(() => {
    const coreOptions = CHANNELS_OPTIONS.map((channel) => ({
      id: channel.id,
      label: channel.label,
    }));
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, []);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId?.(+params.option.id);
    } else {
      onChangeId?.(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={channelsOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur?.();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default DeviceChannelsSelect;
